import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { HeaderComponentContainer } from "../styles_vanilla.css";
import { headerSubtitle, headerTitle } from "./styles_vanilla.css";

type HeaderComponentProps = {
  colHeaderTitle: string;
  secondaryTitle: string;
};

export const HeaderComponent: React.FC<HeaderComponentProps> = ({
  colHeaderTitle,
  secondaryTitle,
}) => {
  return (
    <Flex className={HeaderComponentContainer} gap={Sizes.XS} flexDirection="column">
      <Text variant="regular-md" className={headerTitle}>
        {colHeaderTitle}
      </Text>
      <Text variant="regular-md" className={headerSubtitle}>
        {secondaryTitle}
      </Text>
    </Flex>
  );
};
